export const getBonusRecordColorStatus = (status) => {
  switch (status) {
    case 'Данные получены':
    case 'received':
      return 'primary.main';
    case 'Данные отправлены в МПШ':
    case 'sent':
      return 'warning.main';
    case 'Получен ответ от МПШ: успешно':
    case 'success':
      return 'success.main';
    case 'Получен ответ от МПШ: ошибка':
    case 'error':
      return 'error.main';
    case 'Отменен':
    case 'Отменена':
    case 'canceled':
      return 'text.secondary';
  }
};
